import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Grid, FormControlLabel, Switch, Button } from "@material-ui/core";

import { useStreamProvider } from "../../api/StreamProvider";
import { useDataProvider } from "../../api/DataProvider";
import { pDB_user_roles } from "../../utils/parameters";

import { RecorderVideo } from "./RecorderVideo";
import { SourceSelection } from "./SourceSelection";
import { RecordingButtons } from "./RecordingButtons";
import { CameraPermissionsPrompt } from "./CameraPermissionsPrompt";
import { VideoTimer } from "./VideoTimer";
import { CustomWebcamOptions } from "../search/CustomFilters";

import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import UndoIcon from "@mui/icons-material/Undo";

import Tooltip from '@mui/material/Tooltip';

import { useTour } from "@reactour/tour";
import { stepsSearchLSE } from "../tour/TourConfig";
import { DeviceQueries } from "../utils/DeviceQueries";

import "../../styles/devices/mob_Home.css";
import "../../styles/devices/mob_VersusMachine.css";
import "../../styles/devices/mob_Hub.css";
import { useSegmenterProvider } from "../../api/SegmenterProvider";
import { useMediapipeHolisticProvider } from "../../api/MediapipeHolisticProvider";
import { CameraTester } from "./CameraTester";
import MouseIcon from '@mui/icons-material/Mouse';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


export function Recorder(props) {
  const { action_send, action_repeat, returnFunction, customTimer } = props

  const { t } = useTranslation("global")
  const { 
    streamVideoWidthRef,
    streamVideoHeightRef,
    streamVideoOriginal,
    streamVideoOut, 
    streamMediaBlobUrl,
    setStreamMediaBlobUrl,
    main_streamSegmentationCanvasOut,

    streamConfigOption,
    setStreamConfigOption,

    startMediapipeHolisticSafeMode,
    stopMediapipeHolisticSafeMode,

    videoRevisedRef
  } = useStreamProvider();

  const { 
    statusSegmenter,
    setStatusSegmenter
  } = useSegmenterProvider();

  const { 
    statusMediapipeHolistic
  } = useMediapipeHolisticProvider();

  const [record_trigger, setRecord_trigger] = useState(null); 


  const { currentUserRole } = useDataProvider();

  const [optionsMenuState, setOptionsMenuState] = useState([
    false,   // offset
    true,  // showFraming
    false,  // activateKeypoints
    false,  // autoControl
    false,  // virtualBG - activate / deactivate
  ]);

  const [blurSettings, setBlurSettings] = useState({
    'blur': 0,
    'image': false
  })

  const queryMatches = DeviceQueries();
  const [deviceId, setDeviceId] = useState(null);
  const [switchSide, setSwitchSide] = useState(true);
  const [openOptionsMenu, setOpenOptionsMenu] = useState(false);
  const [openCameraTester, setOpenCameraTester] = useState(false);

  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const main_videoCanvasRef = useRef(null);
  
  const [ enableSourceWebcam, setSourceEnableWebcam ] = useState(true);
  const [ enableSourceVideo, setSourceEnableVideo ] = useState(false);

  // const [ videoRevised, setVideoRevised ] = useState(false)


  // function handleOpenTour(steps, initStep) {
  //   setSteps(steps);
  //   setCurrentStep(initStep);
  //   setIsOpen(true);
  // }

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  function handleOptionsMenu() {
    setOpenOptionsMenu((state) => !state);
  }

  function swithStatusSegmenter() {
    setStatusSegmenter(!statusSegmenter);
  }

  function swithStatusMediapipeHolistic() {
    console.log("🚀 ~ swithStatusMediapipeHolistic ~ swithStatusMediapipeHolistic:", swithStatusMediapipeHolistic)
    if (!statusMediapipeHolistic){
      startMediapipeHolisticSafeMode()
    }else{
      stopMediapipeHolisticSafeMode()
    }
  }

  function swithOptions() {
    setStreamConfigOption(!streamConfigOption);
  }

  function disabled_btn_evaluate_recording(){
    return streamMediaBlobUrl === undefined ? false : true
  }

  

  return (

    <>
    {/* <Button onClick={swithStatusSegmenter}> "SEGMENTER: "{statusSegmenter ? "ON" : "OFF"} </Button>  
    <Button onClick={swithStatusMediapipeHolistic}> "HOLISTIC: "{statusMediapipeHolistic ? "ON" : "OFF"} </Button>  
 */}


      <Grid container className={`sig_Home_MainSectionContainer ${queryMatches.deviceLandscape ? "sig_Home_MSCLandscape" : ""}`}>
        <Grid item className={switchSide ? "sig_Home_OptionsRight" : "sig_Home_OptionsLeft"}>
          {queryMatches.desktop ? (
            <Grid container className="sig_Home_MainSectionOptions">
              {returnFunction !== undefined && 
                <Button data-tour="tourCam_2b" onClick={returnFunction} className="sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode" variant="contained">
                  <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
                </Button>
              }
              
              <SourceSelection enableWebcam={enableSourceWebcam} enableVideo={enableSourceVideo} deviceId={deviceId} setDeviceId={setDeviceId} /> 

              {/* <Tooltip title={t("sTooltip.help_framing")} placement="bottom-end" arrow>
                <div data-tour='tourCam_1' className="sig_Main_IconButton" onClick={() => setOpenCameraTester(!openCameraTester)}>
                  <CameraEnhanceIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip> */}

              {/* <Tooltip title={t("sTooltip.help_framing")} placement="bottom-end" arrow>
                <div data-tour='tourCam_1' className="sig_Main_IconButton" style={{width: '500px'}} onClick={() => setOpenCameraTester(!openCameraTester)}>
                   {qualityVideoRevised ? "ETORNO EVALUADO - PUEDE GRABAR " : "ENTORNO NO EVALUADO - PULSE ANTES DE GRABAR"} 
                </div>
              </Tooltip> */}
        

              <div>
                  <Button startIcon={videoRevisedRef.current ? null : <MouseIcon style={{ color: 'white' }} />} className={videoRevisedRef.current ? "sig_CameraTester_Button_Evaluation_Validated" : "sig_CameraTester_Button_Evaluation"}  disabled={disabled_btn_evaluate_recording()} onClick={() => { if (!videoRevisedRef.current) { videoRevisedRef.current=false; setOpenCameraTester(true); } }}> 
                      {videoRevisedRef.current ? "ESPACIO DE GRABACIÓN EVALUADO. LISTO PARA GRABAR" : "PULSA AQUÍ PARA EVALUAR TU ESPACIO DE GRABACIÓN"}
                  </Button>
              </div>



              {/* <Tooltip title={t("sTooltip.help_framing")} placement="bottom-end" arrow>
                <div data-tour='tourCam_1' className="sig_Main_IconButton" onClick={() => handleOpenTour(stepsSearchLSE, 0)}>
                  <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip> */}

              {/* <Tooltip title={t("sFilter.cat_options")} placement='bottom-end' arrow>
                <div className="sig_Main_IconButton" onClick={handleOptionsMenu}>
                  {openOptionsMenu ? <SettingsIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" /> : <SettingsOutlinedIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip>  */}

            </Grid>
          ) : queryMatches.devicePortrait ? (
            <>     
            {returnFunction !== undefined &&         
              <Button data-tour="tourCam_2b" onClick={returnFunction} className="sig_Collab_Terms_ReturnButton sig_Collab_Terms_ReturnButtonFullWidth sig_Home_ChangeOnDarkMode" variant="contained">
                <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
              </Button>
            }
            </>
          ) : ( 
            <></>
          )}
          <Grid container className={`sig_Home_MainSectionCamera ${queryMatches.deviceLarge ? "sig_Home_MainSectionCamera_LargeDevice" : ""}`}>
            <Grid item style={{ position: 'relative' }}>
                
                {main_streamSegmentationCanvasOut ?
                  <RecorderVideo stream={main_streamSegmentationCanvasOut}/>
                :
                  <RecorderVideo stream={streamVideoOut}/>
                }

            </Grid>
          </Grid>
          <Grid container className={`sig_Home_MainSectionButtons ${queryMatches.deviceLarge ? "sig_Home_MainSectionButtons_LargeDevice" : ""}`}>
          {queryMatches.desktop ? (
            <>
            <Grid item className="sig_Home_ProgressContainer">
              <VideoTimer />
            </Grid>
            </>
            ) : (
            <Grid container className="sig_Home_MainSectionOptions">
              {queryMatches.deviceLandscape ? (
                <FormControlLabel
                  control={
                    <>
                      <SyncAltIcon className="sig_Home_ChangeOnDarkMode" />
                      <Switch color="primary" onClick={toggleSide} checked={switchSide} />
                    </>
                  }
                />
              ) : (
                <>
                <SourceSelection enableWebcam={enableSourceWebcam} enableVideo={enableSourceVideo} deviceId={deviceId} setDeviceId={setDeviceId} /> 
                </>
              )}
              
            </Grid>
            )}
            <Grid item className="sig_Home_ButtonsContainerOuter">
              { videoRevisedRef.current &&  streamVideoOut &&
                <RecordingButtons stream={streamVideoOut} action_btn_send={action_send} action_btn_repeat={action_repeat} record_video={true} record_mediapipe={true} customTimer={customTimer} record_trigger={record_trigger} setOpenCameraTester={setOpenCameraTester}/>
              }
                {queryMatches.deviceLandscape ? (
                  <>
                  {returnFunction !== undefined && 
                    <Button data-tour="tourCam_2b" onClick={returnFunction} className="sig_Collab_Terms_ReturnButton sig_Collab_Terms_ReturnButtonFullWidth sig_Home_ChangeOnDarkMode" variant="contained">
                      <UndoIcon className="sig_Collab_UndoIcon" /> {t("strButton.btn_return").toUpperCase()}
                    </Button>
                  }
                  <SourceSelection enableWebcam={enableSourceWebcam} enableVideo={enableSourceVideo} deviceId={deviceId} setDeviceId={setDeviceId} /> 
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : queryMatches.devicePortrait ? (
                  <>
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : (<>
                  </>
                )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* <CustomWebcamOptions openOptionsMenu={openOptionsMenu} setOpenOptionsMenu={setOpenOptionsMenu} optionsMenuState={optionsMenuState} setOptionsMenuState={setOptionsMenuState} blurSettings={blurSettings} setBlurSettings={setBlurSettings}  userAdmin={currentUserRole === pDB_user_roles.admin}/> */}

      <CameraTester 
        openCameraTester={openCameraTester} 
        setOpenCameraTester={setOpenCameraTester} 
        setRecord_trigger={setRecord_trigger} 
        />

      </>
      

    );
  }
